<template>
  <div class="catalogConfiguration" v-show="ready">
    <Draggable v-model="catalog.categories">
      <div class="catalog-category" v-for="(category, categoryIndex) of catalog.categories" :key="'category' + category.id">
        <div class="category__icon">
          <svgicon src="icon/drag.svg" :height="20" :width="12"></svgicon>
        </div>
        <div class="category__content">
          <div class="category__name">{{$to(category.name)}}</div>
          <Draggable v-model="category.items" class="category__items">
            <div class="catalog-item" v-for="(item, itemIndex) of category.items" :key="'item' + category.id + itemIndex">
              <ToggleSwitch v-model="category.items[itemIndex].selected" text-after>{{$to(category.items[itemIndex].name)}}</ToggleSwitch>
              <div class="item__icon">
                <svgicon src="icon/drag.svg" :height="20" :width="12"></svgicon>
              </div>
            </div>
          </Draggable>
        </div>
      </div>
    </Draggable>
  </div>
</template>

<script>
  import Draggable from "vuedraggable";
  import {Core} from "@/core/Core";
  import ToggleSwitch from "@/components/tools/ToggleSwitch";

  export default {
    name: "catalogConfiguration",

    components: { ToggleSwitch, Draggable },

    props: {
      value: Object
    },

    data() {
      return {
        ready: false,
        inventory: null,
        items: [],
        categories: [],
        catalog: {
          categories: []
        }
      }
    },

    watch: {
      "catalog": {
        deep: true,
        handler() {
          this.emitChange();
        }
      }
    },

    async mounted() {
      this.inventory = await this.$store.getters.getContextInventory;
      this.catalog = JSON.parse(JSON.stringify(this.value));

      this.$store.commit('showSpinner', true);
      let [categories, items] = await Promise.all([
            Core.request("GET", `/api/inventory/${this.inventory.id}/categories`),
            Core.request("GET", `/api/inventory/${this.inventory.id}/items`)
          ]);
      this.items = items.map(i => ({
        id: i.id,
        selected: true,
        name: i.name
      }));
      this.categories = categories.map(c => ({
          id: c.id,
          items: c.items.map(itemId => this.items.find(i => i.id === itemId)),
          name: c.name
      }));
      if (!this.catalog.id) {
        this.catalog.categories = this.categories;
      } else {
        for (let category of this.catalog.categories) {
          let mappedCategory = this.categories.find(c => c.id === category.id);
          if (mappedCategory) {
            category.name = mappedCategory.name;
            let items = [];
            for (let itemId of category.items) {
              let foundItem = this.items.find(i => i.id === itemId);
              if (foundItem) {
                foundItem.selected = true;
                items.push(foundItem);
              }
            }
            for (let item of mappedCategory.items) {
              if (!item) {
                continue;
              }
              let foundItem = category.items.find(i => i === item.id);
              if (!foundItem) {
                item.selected = false;
                items.push(item);
              }
            }
            category.items = items;
          }
        }
        for (let category of this.categories) {
          let foundCategory = this.catalog.categories.find(c => c.id === category.id);
          if (!foundCategory) {
            this.catalog.categories.push(category);
          }
        }
      }

      this.ready = true;
      hideSpinner();
    },

    methods: {
      emitChange() {
        if (!this.catalog) {
          return;
        }
        this.value.categories = this.catalog.categories.map(c => ({
          id: c.id,
          items: c.items.filter(i => i.selected).map(i => i.id)
        }));
      }
    }
  }
</script>

<style lang="scss" scoped>
  .catalog-category {
    display: flex;
    padding: 15px;
    background-color: #f5f5f5;
    border-radius: 16px;
    cursor: grab;

    &:not(:last-child) {
      margin-bottom: 15px;
    }

    .category__content {
      flex-grow: 1;
    }

    .category__icon {
      flex-shrink: 0;
      fill: #fc6650;
      margin-right: 15px;
    }

    .category__name {
      font-weight: bold;
      margin-bottom: 15px;
      font-size: 18px;
      padding-left: 15px;
    }
  }
  .category__items {
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }
  .catalog-item {
    background-color: rgba(255, 255, 255, 0.5);
    border-radius: 10px;
    padding: 0 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &:not(:last-child) {
      margin-bottom: 6px;
    }
    .item__icon {
      fill: #e6e6e6;
    }
  }
</style>